import { z } from 'zod';

import { NotificationTemplateWritableShape } from '../notification-template-create/notification-template-create';

/**
 * Editing a template (`notifications.manage`).
 *
 * `key` and `channel` are **omitted from the shape**, not merely rejected — the
 * discipline `ViolationTypeUpdateSchema` and `UpdateLegalDocumentSchema` both
 * keep. A partial patch, so leaving `translations` out means "leave the copy
 * alone" rather than "blank it"; the surface that edits copy and the surface
 * that retires a template are the same form, and one must not silently do the
 * other's work.
 */
export const NotificationTemplateUpdateSchema = z
  .object(NotificationTemplateWritableShape)
  .partial()
  .strict();

export type NotificationTemplateUpdateRequest = z.infer<typeof NotificationTemplateUpdateSchema>;
